import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  coverImage: string;
  author: string;
  date: string;
  tags: string[];
}

export default function ArticleCard({ id, title, slug, excerpt, coverImage, author, date, tags }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={coverImage}
          alt={`${title} - 蓝莓视频资讯`}
          title={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2">
          {tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
        <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{author}</span>
          <span>{date}</span>
        </div>
      </div>
    </Link>
  );
}